"use client";

import Image from "next/image";
import Link from "next/link";
import { useDynamicConfig } from "@statsig/react-bindings";
import { TenantInfoKey } from "@/lib/enum/statsig/tenantInfoKey";
import { getTenantLogoUrl } from "@/lib/tenantAssets";
import lightModeLogo from "@/public/artefact_dark.svg";
import darkModeLogo from "@/public/artefact_light.svg";

type Props = {
  isAdmin: boolean;
  height: number;
};

export default function NavLogo({ isAdmin, height }: Props) {
  const config = useDynamicConfig("tenant_info");
  const tenantId = (config.get(TenantInfoKey.TenantId) as string) || "";
  const homepage = (config.get(TenantInfoKey.TenantHomepage) as string) || "/";

  const variant = isAdmin ? "dark" : "light";
  const remoteUrl = getTenantLogoUrl(tenantId, variant);

  const src = remoteUrl || (isAdmin ? darkModeLogo : lightModeLogo);

  return (
    <Link href={homepage}>
      <div style={{ height, aspectRatio: "4 / 1", position: "relative" }}>
        <Image src={src} alt="Logo" fill style={{ objectFit: "contain" }} />
      </div>
    </Link>
  );
}


